import { render, staticRenderFns } from "./ClienteList.vue?vue&type=template&id=1224d262&scoped=true&"
import script from "./ClienteList.vue?vue&type=script&lang=js&"
export * from "./ClienteList.vue?vue&type=script&lang=js&"
import style0 from "./ClienteList.vue?vue&type=style&index=0&id=1224d262&lang=scss&scoped=true&"
import style1 from "./ClienteList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224d262",
  null
  
)

export default component.exports